import { RestService, Rest } from '@abp/ng.core';
import type { PagedResultDto } from '@abp/ng.core';
import { Injectable, inject } from '@angular/core';
import type { GetPlantsInputDto, PlantCreateDto, PlantDto, PlantExcelDownloadDto, PlantUpdateDto } from '../dtos/plant/models';
import type { DownloadTokenResultDto, GetByIdsInputDto } from '../dtos/shared/models';

@Injectable({
  providedIn: 'root',
})
export class PlantService {
  private restService = inject(RestService);
  apiName = 'General';
  

  create = (input: PlantCreateDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, PlantDto>({
      method: 'POST',
      url: '/api/general/plants',
      body: input,
    },
    { apiName: this.apiName,...config });
  

  delete = (id: number, config?: Partial<Rest.Config>) =>
    this.restService.request<any, void>({
      method: 'DELETE',
      url: `/api/general/plants/${id}`,
    },
    { apiName: this.apiName,...config });
  

  deleteByIds = (ids: number[], config?: Partial<Rest.Config>) =>
    this.restService.request<any, void>({
      method: 'DELETE',
      url: '/api/general/plants',
      params: { ids },
    },
    { apiName: this.apiName,...config });
  

  get = (id: number, config?: Partial<Rest.Config>) =>
    this.restService.request<any, PlantDto>({
      method: 'GET',
      url: `/api/general/plants/${id}`,
    },
    { apiName: this.apiName,...config });
  

  getDownloadToken = (config?: Partial<Rest.Config>) =>
    this.restService.request<any, DownloadTokenResultDto>({
      method: 'GET',
      url: '/api/general/plants/download-token',
    },
    { apiName: this.apiName,...config });
  

  getList = (input: GetPlantsInputDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, PagedResultDto<PlantDto>>({
      method: 'GET',
      url: '/api/general/plants',
      params: { consumableId: input.consumableId, consumableName: input.consumableName, consumableCode: input.consumableCode, consumableTypeName: input.consumableTypeName, geneticMaterialId: input.geneticMaterialId, geneticMaterialName: input.geneticMaterialName, plantTypeId: input.plantTypeId, plantTypeName: input.plantTypeName, sorting: input.sorting, skipCount: input.skipCount, maxResultCount: input.maxResultCount },
    },
    { apiName: this.apiName,...config });
  

  getListAsExcelFile = (input: PlantExcelDownloadDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, Blob>({
      method: 'GET',
      responseType: 'blob',
      url: '/api/general/plants/as-excel-file',
      params: { downloadToken: input.downloadToken, fields: input.fields, consumableId: input.consumableId, consumableName: input.consumableName, consumableCode: input.consumableCode, consumableTypeName: input.consumableTypeName, geneticMaterialId: input.geneticMaterialId, geneticMaterialName: input.geneticMaterialName, plantTypeId: input.plantTypeId, plantTypeName: input.plantTypeName, sorting: input.sorting, skipCount: input.skipCount, maxResultCount: input.maxResultCount },
    },
    { apiName: this.apiName,...config });
  

  getListByIds = (input: GetByIdsInputDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, PlantDto[]>({
      method: 'GET',
      url: '/api/general/plants/by-ids',
      params: { ids: input.ids },
    },
    { apiName: this.apiName,...config });
  

  update = (id: number, input: PlantUpdateDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, PlantDto>({
      method: 'PUT',
      url: `/api/general/plants/${id}`,
      body: input,
    },
    { apiName: this.apiName,...config });
}
